import inserted from '@mailobj-browser/front/js/tree/inserted.js'
import { removed } from '@mailobj-browser/front/js/tree/tree.js'
import { elements } from '../../../styles.js'
import * as sharedClasses from '#utilities/js/ea/sharedClasses.js'

export default iframe => {
  const { ownerDocument } = iframe
  const { body } = ownerDocument

  queueMicrotask(async () => {
    // @todo FB A supprimer quand web2 et default seront fusionnés
    await inserted(iframe, body)
    sharedClasses.add(iframe, elements.message_mailbox)
  })

  queueMicrotask(async () => {
    // @todo FB A supprimer quand web2 et default seront fusionnés
    await removed(iframe)
    sharedClasses.remove(iframe, elements.message_mailbox)
  })
}
